import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import {useEffect} from "react";
import CreateUserModal from "../../../components/CreateUserModal";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Authorize from "../../../components/Authorize";

export interface UserItemProps {
    id: string;
    name: string;
}

const Overview = (): React.ReactElement => {
    const [open, setOpen] = React.useState(false);
    const [list, setList] = React.useState<UserItemProps[]>([]);

    const deleteUser = async(id: string, name: string): Promise<void> => {
        const confirmed = window.confirm(`Do you really want to delete user: ${name}`);

        if(!confirmed) return;

        const result = await fetch(`/api/v1/Users/${id}`, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("echo-si-jwt")}`
            }
        });

        if(result.status == 200) {
            fetchList().then(setList);
            return;
        }
        else return;
    };

    const fetchList = async () => {
        const result = await fetch("/api/v1/Users", {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("echo-si-jwt")}`
            }
        });

        if(result.status == 200) return (await result.json()).result;
        else return [];
    }

    useEffect(() => {
        fetchList().then(setList);
    }, []);

    return (
        <>
            <Authorize/>
            <CreateUserModal
                show={open}
                handleClose={() => setOpen(false)}
                reFetch={() => fetchList().then(setList)}
            />
            <Container maxWidth="lg">
                <Stack spacing={3}>
                    <Button variant="contained" onClick={() => setOpen(true)}>Create user</Button>
                    <Box sx={{flexGrow: 1}}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Username</TableCell>
                                        <TableCell align="right">Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {list.map((row) => (
                                        <TableRow
                                            key={row.name}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                {row.name}
                                            </TableCell>
                                            <TableCell align="right">
                                                <Button variant="text" color="error" onClick={() => deleteUser(row.id, row.name)}>Delete</Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Stack>
            </Container>
        </>
    );
};

export default Overview;